export const EMAIL_BODY = `Hi {name},

Thank you for booking {bookingName} with us!

We are pleased to confirm that your booking has been successfully completed.You can view all the details of your booking by following the link below:

View Booking Details

{bookingDetailsLink}

Cancellation Policy

{cancellationPolicy}

If you need to cancel your booking, you can do so by clicking this link
{bookingCancelLink}

For more information about our cancellation policy, please refer to the Cancellation Policy.

Terms and Conditions
By completing this booking, you agree to our Terms and Conditions 

{termsAndConditionsLink}.

We look forward to providing you with a memorable experience. Should you have any questions or require further assistance, feel free to reach out.

Kind regards,
{companyName}`;

export const EMAIL_SUBJECT = 'Booking info';

export const EMAIL_INFO = {
  name: 'the name and surname of the person who made the booking',
  bookingName: 'the name of booked activity or accommodation',
  bookingDetailsLink: 'a link with booking details',
  bookingCancelLink: 'a link to cancel the booking',
  termsAndConditionsLink: 'a link for terms and conditions',
  companyName: 'Name of your company'
};
